<template>
  <b-row>
    <b-col cols="12" md="3">
      <FormulateInput
        class="p-0"
        name="name"
        label="Nama Penjadwalan"
        placeholder="Masukkan nama penjadwalan"
        validation="bail|required|max:256,length"
        :help="true"
        :disabled="isLoading"
      />
    </b-col>

    <b-col v-if="$route.params.id" cols="12" md="3">
      <p>Status</p>
      <McBadge
        type="button"
        size="large"
        :text="status.name"
        :variant="variantMappings[status.name]"
      />
    </b-col>
  </b-row>
</template>

<script>
import McBadge from '@/components/McBadge'

export default {
  components: {
    McBadge,
  },
  inject: ['isLoading'],
  props: {
    value: {},
    showResponse: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:value'],
  data() {
    return {
      variantMappings: {
        Aktif: 'outlineSuccess',
        'Tidak Aktif': 'outlineWarning',
        'Gagal Dijalankan': 'outlineDanger',
      },
    }
  },
  computed: {
    status() {
      return this.showResponse.status
    },
  },
}
</script>
